export default __webpack_public_path__ + "static/media/chapter11.c0b9e438.svg";